import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../../style/auth.css";
import { Loader, LoginForm } from "@/components";
import { useLoginState } from "../../../hooks/useLoginState";

const Login = () => {
  const loginState = useLoginState();

  if (loginState.isLoading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  const Selectezi = "Selectezi";
  return (
    <>
      <Container fluid>
        <Row className="sponsersettingrelative">
          <Col lg="2" md="2" sm="12" className="p-lg-5">
            <div>
              <h4 className="font-weight-bold selectezilogo">
                {Selectezi.toUpperCase()}
              </h4>
            </div>
          </Col>
          <Col lg="8" md="7" sm="12" className=" p-3 loginsetheight">
            <Col lg="8" className="mx-auto height-login">
              <h3 className="mb-2  font-bold mt-lg-5">Login</h3>
              <p className="mb-3 login_font">
                Login and Establish your business Shop to join the business
                network.where you can engage your business with thousands of new
                clients along your area.
              </p>
              <LoginForm {...loginState} />
            </Col>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
